module.exports = __webpack_public_path__ + "media/customizations/regencyatfolsomranch/logo-6aab4bbfd203963314604bb6b7d49f5f.png";